var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfoldMoreDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82997 12.0001L8.28997 9.54011C8.67997 9.15011 8.67997 8.52011 8.28997 8.13011C7.89997 7.74011 7.26997 7.74011 6.87997 8.13011L3.69997 11.3001C3.30997 11.6901 3.30997 12.3201 3.69997 12.7101L6.87997 15.8801C7.26997 16.2701 7.89997 16.2701 8.28997 15.8801C8.67997 15.4901 8.67997 14.8601 8.28997 14.4701L5.82997 12.0001ZM18.17 12.0001L15.71 14.4601C15.32 14.8501 15.32 15.4801 15.71 15.8701C16.1 16.2601 16.73 16.2601 17.12 15.8701L20.3 12.7001C20.69 12.3101 20.69 11.6801 20.3 11.2901L17.13 8.12011C16.74 7.73011 16.11 7.73011 15.72 8.12011C15.33 8.51011 15.33 9.14011 15.72 9.53011L18.17 12.0001Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldMoreDark);
export default __webpack_public_path__ + "static/media/unfold_moreDark.d3b6089ff03ec8b26f2afd4f3d28d9b4.svg";
export { ForwardRef as ReactComponent };